import Vue from 'vue';
import * as d3 from 'd3';
import highlightSelectedRange from '../../util/density/highlightSelectedRange';
import CalculatePreviewHighlightDensity from '../../util/density/CalculatePreviewHighlightDensity';
import truncateMatrixAndCalcPreviewDensity from '../../util/density/truncateMatrixAndCalcPreviewDensity';


const processHighlightOwningNode = () => {

  /* 
    This function expects the truncated value matrix for the highlight-owning node.
    It then updates the global highligh array and computes the rectangles for the highlighting.
    The function returns the paths for the highlight rectangles to be plotted on the dist preview.
  */

  // Determine highlight-owning node
  // This is the node ID, not the UUID 
  // TODO: Ideally, make it unique!
  let nodeIDHighlight = Vue.prototype.$globalSharedData.idOfNodeThatOwnsHighlight; 


  if (nodeIDHighlight) {

    // Get its data matrix
    // TODO: Ideally, use some UUID; not the ambiguous node.id
    // Here, we could pick up the wrong data matrix if we do not consider a unique UUID (or assume that highlight must be in currently active module)
    let matrix;
    for (let [key, value] of Object.entries(Vue.prototype.$globalSharedData.globalNodeData)) {
      if (value.nodeID == nodeIDHighlight){
        matrix = value.data;
      }
    }

    if (matrix) {

      // Truncate matrix and calculate preview density
      let previewDensityResults = truncateMatrixAndCalcPreviewDensity(matrix);

      // console.log('Highlight-owning node does stuff now and updates global highlight array');

      let matrixTruncatedForPreview = previewDensityResults.matrixTruncatedForPreview;

      // Update of the global highlight array since we have now drawn new numbers for the highlight-owning node as well
      Vue.prototype.$globalTempHighlightArray = matrixTruncatedForPreview;

      // Get the lower and upper bounds
      let lowerBound = parseFloat(Vue.prototype.$globalSharedData.lastSliderPositionLowerBoundAsString);
      let upperBound = parseFloat(Vue.prototype.$globalSharedData.lastSliderPositionUpperBoundAsString);

      highlightSelectedRange(lowerBound, upperBound);

      /*************************************************************************************
        Highlight selected range using one or two rectangles for the highlight-owning node
        (Instead of a KDE)
      **************************************************************************************/

      let highlightResults;
      let pathHighlightLine1ForHighlightOwningNode;
      let pathHighlightLine2ForHighlightOwningNode;

      if ( (Vue.prototype.$globalHighlightArray) && (Vue.prototype.$globalHighlightArray.length > 0) ) {

        // Create the values for the highlight density
        highlightResults = CalculatePreviewHighlightDensity(matrixTruncatedForPreview[Vue.prototype.$globalSharedData.selectedPeriod]);
        
        if (highlightResults.lowerBound < highlightResults.upperBound) {
          // If the lowerBound is smaller than the upperBound (of the slider), ...
          // ...then we only need a single rectangle to represent the highlighted range
          pathHighlightLine1ForHighlightOwningNode = d3.line()([[highlightResults.lowerBound, 0],[highlightResults.lowerBound, 100], [highlightResults.upperBound, 100], [highlightResults.upperBound, 0]]);
          pathHighlightLine2ForHighlightOwningNode = '';

        } else if (highlightResults.lowerBound > highlightResults.upperBound) {
          
          // We need two rectangles:
          // (1) from left end to upperBound
          // (2) from lowerBound to right end
          
          // left rect
          pathHighlightLine1ForHighlightOwningNode = d3.line()([[highlightResults.minX, 0],[highlightResults.minX, 100], [highlightResults.upperBound, 100], [highlightResults.upperBound, 0]]);
          
          // right rect
          pathHighlightLine2ForHighlightOwningNode = d3.line()([[highlightResults.lowerBound, 0],[highlightResults.lowerBound, 100], [highlightResults.maxX, 100], [highlightResults.maxX, 0]]);

        }

        let data = {

          nodeID: nodeIDHighlight,
          thisNodeIsHighlightOwner: true,
          pathvalues: previewDensityResults.pathvalues,
          density: previewDensityResults.density,
          canPreviewBeShown: previewDensityResults.canPreviewBeShown,
          previewMessage: previewDensityResults.previewMessage,
          highlightvalues: undefined, 
          matrixTruncatedForPreview: previewDensityResults.matrixTruncatedForPreview,
          pathHighlightLine1ForHighlightOwningNode: pathHighlightLine1ForHighlightOwningNode,
          pathHighlightLine2ForHighlightOwningNode: pathHighlightLine2ForHighlightOwningNode

        }

        // Update the dist preview of the highlight-owning node
        Vue.prototype.$eventHub.$emit("DistPreviewPleaseUpdate", data);

        // The other nodes are asked to update themselves only after compile has finished

      }
    }
  }
}

export default processHighlightOwningNode;